export function IconReplication() {
    return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16.5 3 4 4-4 4M20.5 7h-16M8.5 21l-4-4 4-4M4.5 17h16"
    />
  </svg>;
}
